import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  ONBOARDING_STEPS, getStepStates, completedCount, onOnboardingChange,
  checklistDismissed, dismissChecklist, startTour,
} from '../lib/onboarding';

/* Getting-Started checklist for the Dashboard. Tracks REAL actions (marked via
 * markOnboardingStep at the action sites). Shows progress, links each step to
 * where to do it, is dismissible, and hides once everything is complete. */
export default function GettingStartedChecklist() {
  const nav = useNavigate();
  const [states, setStates] = useState(getStepStates());
  const [dismissed, setDismissed] = useState(checklistDismissed());

  useEffect(() => onOnboardingChange(() => {
    setStates(getStepStates());
    setDismissed(checklistDismissed());
  }), []);

  const done = completedCount();
  const total = ONBOARDING_STEPS.length;
  const allDone = done >= total;

  if (dismissed || allDone) return null;

  const pct = Math.round((done / total) * 100);

  return (
    <div style={{ background: 'white', borderRadius: 12, border: '1px solid #e5e7eb', padding: 20, marginBottom: 24 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12 }}>
        <div>
          <div style={{ fontSize: 15, fontWeight: 700, color: '#1f2937' }}>
            <span aria-hidden="true">🚀 </span>Getting started
          </div>
          <div style={{ fontSize: 12, color: '#6b7280', marginTop: 2 }}>
            {done} of {total} done — a quick path to your first procurement workflow.
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <button onClick={() => startTour()}
            style={{ padding: '6px 12px', background: '#eef2ff', color: '#4338ca', border: '1px solid #c7d2fe', borderRadius: 6, fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
            Replay tour
          </button>
          <button onClick={() => dismissChecklist()} aria-label="Dismiss checklist"
            style={{ background: 'none', border: 'none', color: '#9ca3af', fontSize: 18, lineHeight: 1, cursor: 'pointer' }}>×</button>
        </div>
      </div>

      {/* Progress bar */}
      <div style={{ height: 6, background: '#f1f5f9', borderRadius: 9999, marginTop: 12, overflow: 'hidden' }}>
        <div style={{ width: `${pct}%`, height: '100%', background: '#4f46e5', transition: 'width 0.3s' }} />
      </div>

      {/* Steps */}
      <div style={{ marginTop: 14, display: 'flex', flexDirection: 'column', gap: 6 }}>
        {ONBOARDING_STEPS.map(s => {
          const isDone = states[s.id];
          return (
            <button key={s.id} onClick={() => nav(s.path)}
              style={{
                display: 'flex', alignItems: 'flex-start', gap: 10, textAlign: 'left',
                padding: '8px 10px', borderRadius: 8, border: '1px solid #f1f5f9',
                background: isDone ? '#f0fdf4' : 'white', cursor: 'pointer', width: '100%',
              }}>
              <span style={{
                width: 18, height: 18, borderRadius: 9999, flexShrink: 0, marginTop: 1,
                border: `2px solid ${isDone ? '#16a34a' : '#cbd5e1'}`, background: isDone ? '#16a34a' : 'white',
                color: 'white', fontSize: 11, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center',
              }} aria-hidden="true">{isDone ? '✓' : ''}</span>
              <span style={{ minWidth: 0 }}>
                <span style={{ fontSize: 13, fontWeight: 600, color: isDone ? '#166534' : '#1f2937', textDecoration: isDone ? 'line-through' : 'none' }}>{s.label}</span>
                <span style={{ display: 'block', fontSize: 11, color: '#6b7280', marginTop: 1 }}>{s.hint}</span>
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
